import { render, staticRenderFns } from "./MonthlySocsoCIMB.vue?vue&type=template&id=13354dd8&scoped=true"
import script from "./MonthlySocsoCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13354dd8",
  null
  
)

export default component.exports